import { render, staticRenderFns } from "./snippets_tab.vue?vue&type=template&id=4a10e05e"
import script from "./snippets_tab.vue?vue&type=script&lang=js"
export * from "./snippets_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports